import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';
import { ErrorBoundary } from '@components/ErrorBoundary';
import './styles/globals.css';

function Root() {
  const [clientId, setClientId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadConfig = async () => {
      try {
        // Try environment variable first
        const envClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
        if (envClientId) {
          setClientId(envClientId);
          setLoading(false);
          return;
        }

        // Fall back to config file
        const response = await fetch('/config.json');
        const config = await response.json();
        if (config.googleClientId) {
          setClientId(config.googleClientId);
        }
      } catch (error) {
        console.error('Failed to load configuration:', error);
      } finally {
        setLoading(false);
      }
    };

    loadConfig();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
          <p className="text-gray-600 mt-4">Loading...</p>
        </div>
      </div>
    );
  }

  if (!clientId) {
    return (
      <ErrorBoundary>
        <div className="flex items-center justify-center h-screen bg-red-50">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-red-600 mb-2">Configuration Error</h1>
            <p className="text-gray-600 mb-4">Google Client ID is not configured.</p>
            <p className="text-sm text-gray-500">
              Please update <code className="bg-gray-200 px-2 py-1 rounded">/config.json</code> with your Google Client ID
            </p>
          </div>
        </div>
      </ErrorBoundary>
    );
  }

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </GoogleOAuthProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);
